/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { baseurl } from "../Auth/BaseUrl";
import { useSelector } from "react-redux";
// import BaseUrl from "../Auth/BaseUrl";

function Blog() {
  const { id } = useParams();
  const { website } = useSelector((state) => state?.website || {});
  const website_id = website?.website_id || null;
  const agent_id = website?.agent_id || null;
  const [datas, setadatas] = useState([]);
  const GetDAta = () => {
    axios
      .get(`${baseurl}view/supplier/blog/${id}`)
      .then((res) => {
        setadatas(res.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetDAta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <main>
      <section className="page-area area-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 justify-content-start align-items-center">
              <div className="breadcrumb-title text-center">
                <div className="white-headline">
                  {datas?.length === 0 ? (
                    <h2>
                      {/* Latest <span className="sp-color">Blogs</span> */}
                      <span className="sp-color">NOT FOUND</span>
                    </h2>
                  ) : (
                    <h2>
                      Latest <span className="sp-color">Blogs</span>
                    </h2>
                  )}
                </div>
              </div>
              <div className="breadcrumb-page">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
             
                        {" "}
                        <Link
                          to={`${
                            website_id && agent_id
                              ? `/?websiteid=${website_id}&agentid=${agent_id}`
                              : "/"
                          }`}
                        >
                          Home
                        </Link>
               
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Latest Blogs
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="blog-area blog-grid fix area-padding">
        <div className="container">
          <div className="row">
            {datas?.length === 0 && (
              <h2 className="text-center">
                <span className="sp-color">NOT FOUND</span>
              </h2>
            )}

            {datas?.map((e) => {
              return (
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <div className="single-blog">
                    <div className="blog-image">
                      <p className="image-scale" >
                        <Link to={`/blogdetails/${e?.id}`}>
                          <img src={e?.image} alt="" />
                        </Link>
                        <div className="blog-item-date">
                          <span className="date-type">15</span>
                          <span className="years-type">May, 20</span>
                        </div>
                      </p>
                      <div className="blog-content">
                        <div className="blog-meta">
                          <span className="admin-type">
                            <i className="fa fa-user" />
                            {e?.subadmin?.fname}
                          </span>
                          <span className="comments-type">
                            <i className="fa fa-comment-o" />
                            16
                          </span>
                        </div>
                        <Link>
                          <h4>{e?.title}</h4>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </main>
  );
}

export default Blog;
